import * as React from "react";
import { useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxUtil } from "../../fxms/datas/FxUtil";
import { FxMoDetailList } from "./FxMoDetailList";
import { AttrListEdit } from "../datas/OpClass";
import { FxDashEditInfo } from "./FxDashBoard";

/**
 * 관리대상의 상태를 표시하는 컴포넌트
 *
 * @returns
 */
export const FxMoList = (props) => {
  const { moClass, inloNo, index } = props;
  const [moList, setMoList] = useState([]);
  const [children, setChildren] = useState([]);

  console.log("*** FxMoList ***  props = ", props);

  useEffect(() => {
    console.log("*** FxMoList ***  moClass = ", moClass);
    console.log("*** FxMoList ***  inloNo = ", inloNo);
    console.log("*** FxMoList ***  index = ", index);
  }, []);

  // 설치위치가 변경되면 보인다.
  useEffect(() => {
    if (inloNo > 0 && moClass) showMoState(FxmsData.getInlo(inloNo));
  }, [inloNo, index]);

  async function showMoState(inloObj) {
    const uri = "fxMoState/list";
    const para = {};
    const info = inloObj ? inloObj.inloName : inloNo;
    if (inloNo) para.inloNo = inloNo;
    if (moClass) para.moClass = moClass;

    const tmp = [];
    const tmpMoList = [];
    try {
      const list = await FxmsData.GET(uri, para);
      console.log("*** FxMoList *** " + uri + " = ", list);

      if (list && list.data) {
        list.data.sort(function(a, b) {
          const s1 = a.moOnlineStVal + "\t" + a.moName;
          const s2 = b.moOnlineStVal + "\t" + b.moName;
          return s1 > s2 ? 1 : -1;
        });

        for (let mo of list.data) {
          tmp.push(make(mo)); // 인덱스 1부터 시작하도록함
          tmpMoList.push(mo);
        }
      }
      if (tmp.length === 0) {
        tmp.push(makeNoMoInfo("[" + info + "] 관리대상이 존재하지 않습니다."));
      }
      setChildren(tmp);
      setMoList(tmpMoList);
    } catch (error) {
      tmp.push(makeNoMoInfo("[" + info + "] 관리대상 조회 오류"));
    }


    function make(mo) {
      return <FxMoDetailList key={mo.moNo} mo={mo} />;
    }

    function makeNoMoInfo(msg) {
      return (
        <li className="NotFoundMoInfo">
          {msg}
        </li>
      );
    }
  }

  return (
    <>
      <div className="FxMoListTitle">
        전체 <span>{moList.length}</span>개 / 정상
        <span> {moList.filter((mo) => mo.moOnlineStVal === 1).length}</span>
        개  / 이상
        <span>{moList.filter((mo) => mo.moOnlineStVal !== 1).length}</span>
        개(off포함)
      </div>
      <div className="FxMoListBox">
        <ul className="MoStateBox" style={props.style}>
          {children}
          </ul>
      </div>
    </>
  );
};

/**
 * 관리대상상태 대시보드용
 * 개발자 : T/F팀
 * 개발년원 : 2022.11
 * @returns
 */
export const FxMoListDash = (props) => {
  const { id, fxUiGrpItem, editable } = props;
  const [moClass, setMoClass] = useState(null);
  const [inloNo, setInloNo] = useState(-1);
  const [index, setIndex] = useState(0);
  const style = {};

  style.minWidth = fxUiGrpItem.width;
  style.maxWidth = fxUiGrpItem.width;
  style.minHeight = fxUiGrpItem.height;
  style.maxHeight = fxUiGrpItem.height;

  useEffect(() => {
    console.log("*** FxMoListDash ***", props);
  });


  useEffect(() => {
    if (FxUtil.isEmpty(fxUiGrpItem) || FxUtil.isEmpty(fxUiGrpItem.attrObj)) return;
    setMoClass(fxUiGrpItem.attrObj.moClass);
    setInloNo(FxmsData.getUser().inloNo);
  }, [fxUiGrpItem]);

  if (editable) {
    return <FxDashEditInfo>관리대상상태표시</FxDashEditInfo>;
  }
  return (
    <FxMoList moClass={moClass} inloNo={inloNo} index={index} style={style} />
  );
};

/**
 * 관리대상상태 설정
 * 개발자 : T/F팀
 * 개발년원 : 2022.11
 * @param {*} fxUiGrp
 * @param {*} fxUiGrpItem
 * @returns
 */
export function FxMoListConfig(fxUiGrp, fxUiGrpItem) {
  const setList = new AttrListEdit("setting");

  setList.makeAttrSelect(10, "moClass", "관리대상", 300, "code", { cdClass: "MO_CLASS" });
  setList.makeAttrButton(20, "cmdApplyDb", "적용", 100, null, function (data) {
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, data);
  });

  return setList;
}
